import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqs = [
  {
    question: 'Does it sound like a robot?',
    answer: 'Not at all. Our AI voice agents use advanced natural language processing with locally-tuned accents. Most leads can\'t tell the difference between our AI and a real person. We offer voice previews during onboarding so you can hear it yourself.',
  },
  {
    question: 'Does it integrate with Follow Up Boss?',
    answer: 'Yes! We have native integrations with Follow Up Boss, Sierra Interactive, KvCORE, Real Geeks, and more. Lead data, call transcripts, and booked appointments sync automatically to your CRM.',
  },
  {
    question: 'What if the lead asks a complex question?',
    answer: 'The AI is trained to handle common real estate inquiries (pricing, availability, neighborhood info). For complex questions outside its scope, it gracefully schedules a callback with you, ensuring no lead is lost.',
  },
  {
    question: 'How fast does the AI respond to a new lead?',
    answer: 'Under 2 seconds. Research shows that responding within 5 minutes increases conversion by 400%. Our AI responds in under 2 seconds, giving you a massive competitive advantage.',
  },
  {
    question: 'Can I customize the script for different lead sources?',
    answer: 'Absolutely. You can create unique scripts for Zillow leads, Realtor.ca inquiries, website forms, and more. Each script can have different qualifying questions and booking flows.',
  },
  {
    question: 'Is there a long-term contract?',
    answer: 'No. All plans are month-to-month. Cancel anytime with no penalties. We believe in earning your business every month.',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="mb-14"
        >
          <span className="text-xs uppercase tracking-[0.2em] text-[#00E5FF] font-semibold block mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            FAQ
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Frequently Asked Questions
          </h2>
        </motion.div>

        {/* Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="space-y-0" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10 border-t-0 border-l-0 border-r-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-base lg:text-lg text-white hover:text-[#00E5FF] hover:no-underline py-6 transition-colors duration-200"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent
                  className="text-base leading-relaxed text-neutral-400 pb-6"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
